<template>
  <div></div>
</template>

<script>
import AuthenticationService from "@/services/AuthenticationService";
export default {
  name: "SilentRenew",

  mounted() {
    console.log('trying to renew the token')
    AuthenticationService.UserManager.signinSilentCallback();
  },

  methods: {}
    
};
</script>